import { render } from "./Main.vue?vue&type=template&id=d605de96&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=d605de96&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d605de96"

export default script